import { artwork } from "../../assets/categories";
import { spacings } from "../../assets/themes";
import capitalize from "../../utils/capitalize";
import { getCategoryFormUrlById } from "../../utils/index";
import polyglot from "../../utils/polyglot";
import Button from "@/components/button";
import List from "@/components/list";
import Modal from "@/components/modal";
import Shape from "@/components/shape";
import { SHAPE } from "@/components/styles/variants/shape";
import { getUrlParamsForPrivate } from "./utils";

const getCategoriesCustom = (categories) => {
  const allCategories = categories
    .flatMap((path) => {
      const firstLvlCustomCat = path.children?.find((c) => c.isCustom);
      if (firstLvlCustomCat) {
        return {
          label: path.id,
          value: firstLvlCustomCat.id,
          eligible_private: firstLvlCustomCat.eligible_private,
        };
      }
      return path.children.map((subCat) => {
        const customCat = subCat.children?.find((c) => c.isCustom);
        return {
          label: subCat.id,
          value: customCat?.id,
          eligible_private: subCat?.eligible_private,
        };
      });
    })
    .filter((el) => typeof el.value !== "undefined");

  return {
    privateCategories: allCategories.filter((cat) => cat.eligible_private),
    publicCategories: allCategories.filter((cat) => !cat.eligible_private),
  };
};

const CategoryItem = ({ cat, urlParams }) => (
  <List.Item
    chevron
    href={getCategoryFormUrlById(cat.value, urlParams)}
    key={cat.value}
    LeftComponent={() => (
      <Shape.Small
        backgroundColor="transparent"
        css={`
          overflow: hidden;
          margin: ${spacings.xs} 0;
        `}
        shape={SHAPE.SHAPE.ROUND}
      >
        <img
          alt={capitalize(polyglot.t(`categories.${cat.label}.name`))}
          css={`
            width: 100%;
            height: 100%;
            object-fit: cover;
            object-position: right bottom;
          `}
          src={artwork[cat.label]}
        />
      </Shape.Small>
    )}
    withGutters
  >
    <List.Elem.Title className="font-size-sm-4">
      {capitalize(polyglot.t(`categories.${cat.label}.name`))}
    </List.Elem.Title>
  </List.Item>
);

function SelectCategoryModal({ isOpen, close, urlParams, formatedCategories, user }) {
  const { privateCategories, publicCategories } = getCategoriesCustom(formatedCategories);
  return (
    <Modal.Small animate={false} fullScreenOnMobile isOpen={isOpen} onClose={close}>
      <Modal.Item.Header onBack={close}>
        <Modal.Item.Title>{polyglot.t("categories_modal.select_category")}</Modal.Item.Title>
      </Modal.Item.Header>
      {privateCategories.length > 0 && (
        <>
          <List.Header withGutters>
            {polyglot.t("categories_modal.first_name_services", {
              first_name: user?.first_name,
            })}
          </List.Header>
          {privateCategories.map((cat) => (
            <CategoryItem
              cat={cat}
              key={cat.value}
              urlParams={getUrlParamsForPrivate(urlParams, {
                category: cat,
                user,
              })}
            />
          ))}
          {publicCategories.length > 0 && (
            <List.Header withGutters>{polyglot.t("categories_modal.other_services")}</List.Header>
          )}
        </>
      )}
      {publicCategories.length > 0 &&
        publicCategories.map((cat) => (
          <CategoryItem cat={cat} key={cat.value} urlParams={urlParams} />
        ))}
      <Modal.Item.Wrapper>
        <Button.Large className="mt-3" kind="secondary" onClick={close}>
          {polyglot.t("common.cancel")}
        </Button.Large>
      </Modal.Item.Wrapper>
    </Modal.Small>
  );
}

export default SelectCategoryModal;
